import type { OnboardingRulesProgressResponse } from "@ifgengineering/client-invest-sdk";
import {
  ActionableRequirementKey,
  buildDealAnchoredView,
  DealRequirementKey,
} from "./progress";

export const V2B_PRE_APP_PATH = "/app/onboarding-v2b";
export const V2B_ACCREDITATION_PATH = "/app/onboarding-v2b/accreditation";
export const V2B_TAX_AND_OCCUPATION_PATH =
  "/app/onboarding-v2b/tax-and-occupation";
export const V2B_QUIZ_PATH = "/app/onboarding-v2b/quiz";
export const V2B_VERIFICATION_PATH = "/app/onboarding-v2b/identity";
export const V2B_FALLBACK_RETURN_PATH = "/app/deals";

export type { ActionableRequirementKey } from "./progress";

export const REQUIREMENT_PATH: Record<ActionableRequirementKey, string> = {
  taxAndOccupation: V2B_TAX_AND_OCCUPATION_PATH,
  accreditation: V2B_ACCREDITATION_PATH,
  quiz: V2B_QUIZ_PATH,
  verification: V2B_VERIFICATION_PATH,
};

export const isActionableRequirement = (
  key: DealRequirementKey
): key is ActionableRequirementKey => key !== "coolDown";

export const dealIdFromPath = (dealPath: string): string =>
  dealPath.split("/").pop() ?? "";

/** The flow for the section the server wants next, or null when the investor can do nothing there now. */
export const nextSectionPath = (
  progress: OnboardingRulesProgressResponse | null | undefined,
  finished: ActionableRequirementKey
): string | null => {
  const view = buildDealAnchoredView({ progress });
  const next = view?.requirements.find(
    ({ key }) => key === view.nextRequirement
  );
  if (
    !next ||
    next.key === finished ||
    !isActionableRequirement(next.key) ||
    (next.status !== "not_started" && next.status !== "in_progress")
  ) {
    return null;
  }
  return REQUIREMENT_PATH[next.key];
};
